import { createEntityAdapter } from '@reduxjs/toolkit';
import { IDuct } from 'application/components/api/Duct';

export const ductAdapter = createEntityAdapter<IDuct, number>({
  selectId: (project) => project.ductID,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});
